export function formatOverviewAlarmCount(count: number): string | null {
    if (!Number.isFinite(count) || count <= 0) {
        return null;
    }
    if (count >= 100) {
        return '99+';
    }
    return String(count);
}
